import { axios } from '@/utils/axios'
import { orderBy, find } from 'lodash'
import { flightCities } from '@/assets/js/data'
import moment from 'moment'
import getAppInfo from '@/utils/from'
const mainSettings = window.__MICRO_ROOT__
const { airline } = mainSettings
// 获取航点数据
export async function fetchSegmentAirport () {
  try {
    const data = await axios.post('/api/flight/query/airline/segmentAirport')

    if (data) {
      const { baseCities, hotCities } = data
      let list = baseCities.concat(hotCities)
      list = orderBy(list, [(item) => { return item.pinyin }])

      if (list) {
        return list.map((item) => {
          // 约定分组
          const tabs = ['ABCDEF', 'GHJKL', 'MNPQRST', 'WYXZ']
          // 按原数据结构进行重组
          const [code, city, name, letter, pinyin, cityCode, cityAlias, tab] = [item.airportCode, item.chiName, item.airportName, item.firstLetter, item.pinyin, item.cityCode, item.cityAlias, Number(tabs.findIndex(tab => { return tab.indexOf(item.firstLetter) >= 0 }) + 1).toString()]
          const obj = {
            code,
            city,
            name,
            letter,
            pinyin,
            cityCode,
            cityAlias,
            tab
          }
          if (item.isHot === 'YES') {
            obj.num = item.num
          }
          if (item.isInternal === 'ABRORD') {
            obj.other = true
          }
          return obj
        })
      } else {
        return Promise.reject(new Error('航点数据异常'))
      }
    } else {
      return Promise.reject(new Error('航点数据异常'))
    }
  } catch (err) {
    return Promise.reject(err)
  }
}

// 获取在飞航线数据
export async function fetchOnlineCity (params) {
  try {
    const data = await axios.post('/api/flight/query/airline/OnlineCity', params)

    if (data) {
      let { baseCities, hotCities } = data
      baseCities = baseCities || []
      hotCities = hotCities || []
      let list = baseCities.concat(hotCities)
      list = orderBy(list, [(item) => { return item.pinyin }])

      if (list) {
        return list.map((item) => {
          // 约定分组
          const tabs = ['ABCDEF', 'GHJKL', 'MNPQRST', 'WYXZ']
          // 按原数据结构进行重组
          const [code, city, name, letter, pinyin, cityCode, cityAlias, tab] = [item.airportCode, item.chiName, item.airportName, item.firstLetter, item.pinyin, item.cityCode, item.cityAlias, Number(tabs.findIndex(tab => { return tab.indexOf(item.firstLetter) >= 0 }) + 1).toString()]
          const obj = {
            code,
            city,
            name,
            letter,
            pinyin,
            cityCode,
            cityAlias,
            tab
          }
          if (item.isHot === 'YES') {
            obj.num = item.num
          }
          if (item.isInternal === 'ABRORD') {
            obj.other = true
          } else {
            obj.other = false
          }
          return obj
        })
      } else {
        return Promise.reject(new Error('航点数据异常'))
      }
    } else {
      return Promise.reject(new Error('航点数据异常'))
    }
  } catch (err) {
    return Promise.reject(err)
  }
}

// 获取航班查询结果
export async function fetchFlightSearch (params) {
  const result = await axios.post('/api/flight/query/flight', params)
  const { offers = [] } = result
  const { originDestinations = [] } = result.criteria
  // NOTE: 空数据补齐
  if (offers && (!offers.length || offers.length !== originDestinations.length)) {
    const offerGroup = []
    const airport = await flightCities()

    originDestinations.forEach(group => {
      // 判断某一程是否存在
      let offer = find(offers, offer => {
        return find(offer?.detail?.itinerarys, itinerary => {
          const segment = itinerary?.orgDsts?.[0]
          if (segment) {
            return segment.departureCode === group.orgDepCode && segment.arrivalCode === group.orgArrCode && segment.departureDate === moment(group.flightDate).format('YYYY-MM-DD')
          } else {
            return false
          }
        })
      })

      // 不存在则构建 offers 结构，用于渲染偏移价格日历等
      if (!offer) {
        const departure = find(airport, group.depType === 'airport' ? { code: group.depCode } : { cityCode: group.depCode }) || {}
        const arrival = find(airport, group.arrType === 'airport' ? { code: group.arrCode } : { cityCode: group.arrCode }) || {}
        offer = {
          type: 'Flight',
          mustSelect: 'true',
          detail: {
            itinerarys: [],
            segments: [
              {
                airlineCode: airline,
                airlineName: getAppInfo()?.name,
                departureAirPortName: departure.city || '',
                departureCode: group.depCode,
                departureName: departure.city || '',
                arrivalAirPortName: arrival.city || '',
                arrivalName: arrival.city || '',
                arrivalCode: group.arrCode
              }
            ]
          }
        }
      }
      offerGroup.push(offer)
    })

    result.offers = offerGroup
  }
  return result
}

// 价格日历接口 - 偏移量
export async function fetchFareTrend (params) {
  try {
    return await axios.post('/api/flight/query/price/calendar/offset', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 价格日历接口 - 固定日期
export async function fetchFareCalendar (params) {
  try {
    return await axios.post('/api/flight/query/price/calendar/fix', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 航班预订校验
export async function validateIsEnable (params) {
  try {
    return await axios.post('/api/flight/check/near/isEnable', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 下单流程 - 航班产品选择
export async function fetchProductChoose (params) {
  try {
    return await axios.post('/api/order/choose', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 查询产品权益
export async function queryBenefit (params) {
  try {
    return await axios.post('/api/flight/query/benefit', { language: 'zh', ...params })
  } catch (error) {
    return Promise.reject(error)
  }
}

// 查询退改规则 - 国际票
export async function queryRefundRuleInt (params) {
  try {
    return await axios.post('/api/flight/query/inter/refund/change', params)
  } catch (error) {
    return Promise.reject(error)
  }
}
